import './App.css';
import LeftNavHeader from './Components/Nav Component/LeftNavComponent.js';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './Components/Footer Component/Footer.js'
import AnimatedRoutes from './Components/AnimatedRoutes/AnimatedRoutes.js';
//import ScrollToTop from './Components/ScrollToTop';
function App() {

  return (
      <div className="App">
      <Router>
          <div className="app-container"> 
            <LeftNavHeader/>
          <div className="main-container">
          <div className="tags">
                    <span>{"<html/>"}</span>
                    <span>{"<body/>"}</span>
          </div>
          <AnimatedRoutes/>
            <Footer/>
          </div>

          </div>
        </Router>
      </div>
  );
}

export default App;
